module.exports = __webpack_public_path__ + "static/media/parts_24.6ffc27ce.svg";